module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres33u"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "receivedStore": _vm.receivedHres33uIndex,
      "searchBoxAlias": "approve",
      "detailEvent": _vm.detailEvent,
      "approveEvent": _vm.postHres33uSendApprove
    }
  }), _vm._v(" "), _c('detail1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp.tab1),
      expression: "detailDisp.tab1"
    }],
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "buttonLabels": _vm.constLabels.button[_vm.dash.nowLang],
      "detail": _vm.detail.tab1,
      "toggle": _vm.toggle,
      "nowLang": _vm.dash.nowLang
    }
  }), _vm._v(" "), _c('detail2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp.tab2),
      expression: "detailDisp.tab2"
    }],
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "buttonLabels": _vm.constLabels.button[_vm.dash.nowLang],
      "detail": _vm.detail.tab2,
      "toggle": _vm.toggle,
      "nowLang": _vm.dash.nowLang,
      "tab2Tab6Table": _vm.columns[_vm.dash.nowLang].tab2Tab6Table,
      "tab2Tab7Table": _vm.columns[_vm.dash.nowLang].tab2Tab7Table
    }
  }), _vm._v(" "), _c('detail3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp.tab3),
      expression: "detailDisp.tab3"
    }],
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "buttonLabels": _vm.constLabels.button[_vm.dash.nowLang],
      "detail": _vm.detail.tab3,
      "toggle": _vm.toggle,
      "nowLang": _vm.dash.nowLang,
      "tab3Table1": _vm.columns[_vm.dash.nowLang].tab3Table1,
      "tab3Table2": _vm.columns[_vm.dash.nowLang].tab3Table2
    }
  }), _vm._v(" "), _c('detail4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp.tab4),
      expression: "detailDisp.tab4"
    }],
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "buttonLabels": _vm.constLabels.button[_vm.dash.nowLang],
      "detail": _vm.detail.tab4,
      "toggle": _vm.toggle,
      "nowLang": _vm.dash.nowLang,
      "tab4Table1": _vm.columns[_vm.dash.nowLang].tab4Table1,
      "tab4Table2": _vm.columns[_vm.dash.nowLang].tab4Table2
    }
  }), _vm._v(" "), _c('detail5', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp.tab5),
      expression: "detailDisp.tab5"
    }],
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "buttonLabels": _vm.constLabels.button[_vm.dash.nowLang],
      "detail": _vm.detail.tab5,
      "toggle": _vm.toggle,
      "nowLang": _vm.dash.nowLang
    }
  }), _vm._v(" "), _c('detail6', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp.tab6),
      expression: "detailDisp.tab6"
    }],
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "buttonLabels": _vm.constLabels.button[_vm.dash.nowLang],
      "detail": _vm.detail.tab6,
      "toggle": _vm.toggle,
      "nowLang": _vm.dash.nowLang,
      "tab6Table1": _vm.columns[_vm.dash.nowLang].tab6Table1,
      "tab6Table2": _vm.columns[_vm.dash.nowLang].tab6Table2
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a26c08b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres33u/component.vue
// module id = 3947
// module chunks = 1